import { CreditJurisdiction, CreditPlan, CreditPlanStatus } from "@/@types/client-api";

export const DEFAULT_AI_POWERED_TEXT = 'AI powered CLE compliance aid';
export const CREDIT_PLANS_DEBUG_COOKIE_NAME = 'credit_plans_debug_enabled';

export type CreditPlanJurisdiction = CreditJurisdiction & {
  status?: CreditPlanStatus;
  compliancePeriodEndDate?: string;
  flags?: string[];
  plan?: CreditPlan;
  isTransitionalOrNewlyAdmitted?: boolean;
  imagePortrait?: string;
  imageLandscape?: string;
  sortOrder?: number;
};
